import { render } from "./ProductModalDetails.vue?vue&type=template&id=55b074de"
import script from "./ProductModalDetails.vue?vue&type=script&lang=js"
export * from "./ProductModalDetails.vue?vue&type=script&lang=js"

import "./ProductModalDetails.vue?vue&type=style&index=0&id=55b074de&lang=scss"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__